module.exports = function getResource(label, vars = []) {
    let resources = {
        askToCancel: 'Are you sure you want to cancel this reservation?',
        yes: 'Yes',
        no: 'No'
    };

    return resources[label];
};
